export enum PSnackbarType {
  POSITIVE = 'positive',
  WARNING = 'warning',
  NEGATIVE = 'negative',
  INFO = 'info',
}
